import { IFormHandler } from "./forms";
import { IAuthRequest } from "../stores/auth";

export interface ILoginForm {
    email: string;
    password: string;
    rememberMe: boolean;
}

export class LoginForm implements IFormHandler<ILoginForm, IAuthRequest> {
    public readonly initialValue: ILoginForm;

    constructor(data?: IAuthRequest) {
        this.initialValue = this.toForm(data);
    }

    toForm(data?: IAuthRequest): ILoginForm {
        if (!data) {
            return {
                email: '',
                password: '',
                rememberMe: true,
            };
        }

        return {
            email: data.email,
            password: data.password,
            rememberMe: data.rememberMe || false,
        };
    }

    toRequest(data: ILoginForm): IAuthRequest {
        return {
            email: data.email,
            password: data.password,
            rememberMe: data.rememberMe,
        };
    }
} 